import React from 'react';
import PropTypes from 'prop-types';

import Table from '@appComponents/Table';
import {ApiKeyColumns} from '@modules/client/components/ApiKey/components/Table/ApiKeyColumns';
import {ApiKeyRowRenderer} from '@modules/client/components/ApiKey/components/Table/ApiKeyRowRenderer';

const ApiKeyTable = ({clientApiKeys, clientId}) => {
    return (
        <div className='clientApiKeys__table'>
            <Table
                name='clientApiKeysList'
                columns={ApiKeyColumns}
                data={clientApiKeys}
                noDataText='No API keys found'
                pagination={false}
                rowRenderer={ApiKeyRowRenderer}
                rowRendererProps={{clientId: clientId}}
            />
        </div>
    );
};

ApiKeyTable.defaultProps = {
    clientApiKeys: [],
};

ApiKeyTable.propTypes = {
    clientApiKeys: PropTypes.array,
    clientId: PropTypes.string,
};

export default ApiKeyTable;
